var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9868 0C12.6746 0 0 12.4569 0 27.769C0 43.0812 12.6746 55.7558 27.9868 55.7558C43.299 55.7558 55.7558 43.0812 55.7558 27.769C55.7558 12.4569 43.299 0 27.9868 0ZM42.688 31.036H31.2537V42.688C31.2537 44.4892 29.7869 45.955 27.9868 45.955C26.1856 45.955 24.7199 44.4892 24.7199 42.688V31.036H13.0678C11.2666 31.036 9.80083 29.5702 9.80083 27.769C9.80083 25.9678 11.2666 24.5021 13.0678 24.5021H24.7199V13.0678C24.7199 11.2666 26.1856 9.80083 27.9868 9.80083C29.7869 9.80083 31.2537 11.2666 31.2537 13.0678V24.5021H42.688C44.4881 24.5021 45.955 25.9678 45.955 27.769C45.955 29.5702 44.4881 31.036 42.688 31.036Z",
    fill: "#545871"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.fbcd6288.svg";
export { ForwardRef as ReactComponent };